import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-weather2",
  "use": "icon-weather2-usage",
  "viewBox": "0 0 354.33 199.74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 354.33 199.74\" id=\"icon-weather2\"><defs></defs><title>阴天</title><g id=\"icon-weather2_图层_2\" data-name=\"图层 2\"><g id=\"icon-weather2_WEATHER_ICONS_SET_BY_RedKoala\" data-name=\"WEATHER ICONS SET BY RedKoala\"><path id=\"icon-weather2_DARK_CLOUD\" data-name=\"DARK CLOUD\" class=\"cls-1\" d=\"M307.6,106.27H287.73a55.08,55.08,0,0,0,.44-6.84,53.77,53.77,0,0,0-79.74-47.08A77.46,77.46,0,0,0,57.69,77.46c0,.65,0,1.29.05,1.94C25.75,80,0,106.42,0,138.91a59.66,59.66,0,0,0,26.17,49.52,46.59,46.59,0,0,0,30.47,11.31h251a46.74,46.74,0,0,0,0-93.47ZM135.15,44a33.43,33.43,0,0,0-33.44,33.24v.46a10,10,0,0,1-9.6,10.39h-.39a10,10,0,0,1-10-9.61v-.15c0-.28,0-.54,0-.8v-.17A53.46,53.46,0,0,1,135.15,24a10,10,0,0,1,0,20Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/weather2.svg
// module id = 8FvU
// module chunks = 183